import { render } from "./CredentialsManager.vue?vue&type=template&id=58ccfffa&scoped=true"
import script from "./CredentialsManager.vue?vue&type=script&lang=js"
export * from "./CredentialsManager.vue?vue&type=script&lang=js"

import "./CredentialsManager.vue?vue&type=style&index=0&id=58ccfffa&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ccfffa"]])

export default __exports__